import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React from 'react';
import {
	DECLINE_PAYMENT_MODAL__BODY_TEXT_TITLE,
	DECLINE_PAYMENT_MODAL__CANCEL,
	DECLINE_PAYMENT_MODAL__SUBMIT,
	DECLINE_PAYMENT_MODAL__TITLE,
} from '../data/constants';

interface DeclinePaymentModalProps {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
}

const DeclinePaymentModal = (props: DeclinePaymentModalProps) => {
	const { open, onClose, onConfirm } = props;
	return (
		<Dialog open={open} onClose={onClose}>
			<DialogTitle>{DECLINE_PAYMENT_MODAL__TITLE}</DialogTitle>
			<DialogContent>
				<DialogContentText>
					{DECLINE_PAYMENT_MODAL__BODY_TEXT_TITLE}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} color='neutralButton'>
					{DECLINE_PAYMENT_MODAL__CANCEL}
				</Button>
				<Button onClick={onConfirm} variant='contained' color='primary'>
					{DECLINE_PAYMENT_MODAL__SUBMIT}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default DeclinePaymentModal;
